// Dependencies
import React, { Component } from "react";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router-dom";

// Store
import { subsidiariesStore } from "../store/store";

// Components
import SubsidiariesList from "./SubsidiariesList/SubsidiariesList.component";
import Footer from "../../home/components/Footer/footer.component";

// Styles
import "./SubsidiariesPage.component.scss";

class SubsidiariesPage extends Component {
    render() {
        return (
            <Provider store={subsidiariesStore}>
                <div id="SubsidiariesPage">
                    <Switch>
                        <Route
                            path={"/admin/subsidiaries"}
                            component={SubsidiariesList}
                        />
                    </Switch>
                    <Footer />
                </div>
            </Provider>
        );
    }
}

export default SubsidiariesPage;
